import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Departments() {
  const [list, setList] = useState<any[]>([]);
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState('');

  const load = () => api('/departments').then(setList).catch(() => {});
  useEffect(load, []);

  const add = async () => {
    if (!name) return;
    await api('/departments', {
      method: 'POST',
      body: JSON.stringify({ name, parent_id: parentId || null }),
    });
    setName('');
    setParentId('');
    load();
  };

  const del = async (id: number) => {
    if (!confirm('确认删除该部门？')) return;
    await api('/departments/' + id, { method: 'DELETE' });
    load();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">部门管理</h2>
      <div className="flex gap-2">
        <input
          className="border rounded px-3 py-2"
          placeholder="部门名称"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <select
          className="border rounded px-3 py-2"
          value={parentId}
          onChange={(e) => setParentId(e.target.value)}
        >
          <option value="">无上级（顶级部门）</option>
          {list.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        <button onClick={add} className="bg-brand-600 text-white rounded px-4 py-2 hover:bg-brand-700">
          添加
        </button>
      </div>
      <table className="w-full bg-white rounded-xl shadow text-sm">
        <thead>
          <tr className="text-slate-500 text-left">
            <th className="p-3">ID</th>
            <th>名称</th>
            <th>上级部门</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list.map((d) => (
            <tr key={d.id} className="border-t">
              <td className="p-3">{d.id}</td>
              <td>{d.name}</td>
              <td>{list.find((x) => x.id === d.parent_id)?.name || '—'}</td>
              <td>
                <button className="text-red-500" onClick={() => del(d.id)}>
                  删除
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
